import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "IQ_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#IQ_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "IQ_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#IQ_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v8h32V0H0z", fill: "#BF2714" }), /* @__PURE__ */ e.createElement("path", { d: "M0 16v8h32v-8H0z", fill: "#272727" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.337 12.811C6.247 14.117 5 15 5 15s1.09 0 1.507-.874h8.917V12.2s-.186-.925-.98-.925c-.795 0-.973.925-.973.925h-3.137l3.035-2.68-.59-.52-3.371 2.976v.63h4.785v-.37s.027-.216.25-.216c.224 0 .17.215.17.215v.793h-6.03v-1.084l-.653.291v.793s-.8-.217-1.305-.217c-.506 0-.536-.576-.536-.576l-.752.576zm12.11.075l.49 1.218H15.99v-4.89l.821.264v3.408h.636zm9.065 0L27 14.104h-1.946v-4.89l.82.264v3.408h.637zm-2.41-3.621l-.507.343v3.274h-.517v-2.626l-.85.49v2.136h-.572v-1.483l-.646.416v.403s-1.244.086-1.244 1.845h4.33l.006-4.798zm-16.61 5.7c.157 0 .284-.111.284-.25 0-.137-.127-.25-.284-.25-.156 0-.283.113-.283.25 0 .139.127.25.283.25zm14.423-5.323c-.22.29-.888 0-.888 0l1.893-.22c-.196.382-1.005.22-1.005.22z",
      fill: "#009C4E"
    }
  )))
), a = t;
export {
  a as default
};
